import React from "react";
import DashboardLayout from "../components/DashboardLayout";
import { AGENTS } from "../data/agents";
import AgentIcon from "../components/AgentIcon";
import { useT } from "../lib/i18n";

export default function AgentsCatalog() {
  const { t } = useT();
  return (
    <DashboardLayout title={t("Expert agents catalog")}>
      <div className="max-w-3xl">
        <p className="text-[#475569] text-lg leading-relaxed">{t("Each agent has a defined persona, scope and analysis style. Mix and match to match your decision.")}</p>
      </div>
      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {AGENTS.map((a) => (
          <div key={a.id} className="bg-white border border-slate-200 rounded-xl p-6">
            <div className="w-10 h-10 rounded-md bg-[#0B1B3D] grid place-items-center text-white"><AgentIcon name={a.icon} className="w-5 h-5" /></div>
            <p className="mt-4 font-display font-extrabold text-[#0B1B3D] text-lg">{a.name}</p>
            <p className="text-xs font-mono-kz text-[#0EA5E9] tracking-widest font-bold mt-1">{a.specialty.toUpperCase()}</p>
            <p className="mt-3 text-sm text-[#475569]"><span className="font-bold text-[#0B1B3D]">{t("When to use: ")}</span>{a.when_to_use}</p>
            <p className="mt-2 text-sm text-[#475569]"><span className="font-bold text-[#0B1B3D]">{t("Analysis: ")}</span>{a.analysis_type}</p>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
